import { render, staticRenderFns } from "./IndemnityPriceClinicTemplateDeleteModal.vue?vue&type=template&id=7670d2a3&scoped=true"
import script from "./IndemnityPriceClinicTemplateDeleteModal.vue?vue&type=script&lang=js"
export * from "./IndemnityPriceClinicTemplateDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./IndemnityPriceClinicTemplateDeleteModal.vue?vue&type=style&index=0&id=7670d2a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670d2a3",
  null
  
)

export default component.exports